import React from 'react'
import { useGetIdentity } from 'react-admin'
import { CircularProgress } from '@mui/material'
import { DashboardSales } from './DashboardSales'
import { DashboardOperations } from './DashboardOperations'
import { DashboardOperationsVietur } from './DashboardOperationsVietur'

export const Dashboard = () => {
  const { identity, isLoading } = useGetIdentity()
  if (isLoading) {
    return <CircularProgress />
  } else if (identity?.dashboard === 'SELLER') {
    return <DashboardSales />
  } else if (identity?.dashboard === 'OPERATIONS') {
    return <DashboardOperations />
  } else if (identity?.dashboard === 'OPERATIONS_VIETUR') {
    return <DashboardOperationsVietur />
  } else {
    return null
  }
}
